module.exports = __webpack_public_path__ + "img/bank6.297db20c.png";